export default {
  skip_to_main_content: 'Passa al contenuto principale',
  show_system_messages: 'Mostra i messaggi di sistema',
  dont_show_system_messages: 'Nascondi i messaggi di sistema',
  logged_in: "L'inquilino è autenticato",
  logged_out: 'Utente anonimo',
  button_tooltip_switch_locale: 'Cambia locale',
  button_tooltip_activate_voice_recognition: 'Attiva il riconoscimento vocale',
  date_input: 'Selezioni la data',
  choose_two_dates: 'Selezioni due date',
  date_range: 'Intervallo di date',
  from: 'da',
  to: 'a',
  avatar: 'Avatar',
  exit: 'Uscita',
  new: 'Nuovo',
  back: 'Indietro',
  address: 'Indirizzo',
  suggestions: 'Suggerimenti',
  senton: 'Inviato su',
  message_placeholder: 'Inserisca qui il suo messaggio...',
  message_aria: 'Inserisca qui il suo messaggio',
  upload_in_progress: 'Caricamento in corso...',
  comment_placeholder: 'Inserisci un commento qui',
  message_button_label: 'Invia',
  please_confirm: 'La prego di confermare',
  no: 'No',
  yes: 'Sì',
  modal_delete_session: 'Elimina sessione',
  modal_delete_session_notification:
    'Se chiude la finestra, anche la sua sessione sarà cancellata.<br>Le va bene?',
  template_contact_time: 'Quando possiamo contattarla?',
  template_pause:
    "La sua sessione è stata messa in pausa. Uno dei nostri addetti all'assistenza si occuperà a breve della sua richiesta.",
  template_continue_after_pause:
    'La sua sessione è continuata. Ora può continuare a scrivere con il nostro chatbot',
  choose_date: 'Selezioni una data',

  button_apply: 'Applica',
  button_cancel: 'Annulla',
  none: 'Nessuno',
  book_appointment: 'Prenota appuntamento',
  address_input: 'Inserimento indirizzo',
  data_processing: 'Elaborazione dati',
  privacy_policy: 'Informativa sulla privacy',
  data_processing_notification_before_link:
    'Per utilizzare questo servizio di chat è necessario che accetti la ',
  data_processing_notification_after_link: '.',
  button_accept: 'Accetta',
  select_date: 'Seleziona data',
  rate_conversation: 'Come valuterebbe questa conversazione?',
  new_ticket_question: "C'è qualcos'altro che posso fare per aiutarla?",
  thank_you:
    'Grazie per il suo supporto. Il suo feedback mi aiuta a migliorarmi costantemente',
  goodbye: 'Arrivederci',
  start_new: 'Inizia una nuova conversazione',
  operator_entered_the_chat: "L'operatore è entrato nella chat",
  operator_left_the_chat: "L'operatore ha lasciato la chat",
  bg_image: process.env.VUE_APP_EN_BG,
  expand_quickreplies: 'Altro',
  collapse_quickreplies: 'Meno',
  login: 'Accedi',
  logout: 'Esci',
  close: 'Chiudi',
  messenger_text: 'Puoi scrivere con il nostro chatbot o contattare direttamente uno dei nostri dipendenti nella nostra chat dal vivo.',
  chat_bot: 'Chat Bot',
  live_bot: 'Live Chat',
  maximize: 'Massimizza',
  minimize: 'Minimizza',
  upload_file: 'Rilascia il file qui per caricarlo',
  upload_file_or: 'o',
  Upload_file_select: 'Aggiungi file',
  upload_file_text: 'Rilascia il file per caricarlo',
  show_attachments: 'Mostra allegato',
  hide_attachments: 'Nascondi allegato',
  tooBig: 'Il file è troppo grande',
  tooSmall: 'Il file è troppo piccolo',
  invalidFileTypeCopilot:
    'Tipo di file non valido. Attualmente sono supportati solo i tipi di file .png, .jpg, .jpeg, .gif.',
  tooManyFiles: 'Carica un massimo di 10 file alla volta',
  uploadError: 'Caricamento fallito. Per favore riprova.',
  maxDocumentsReached: 'Numero massimo di documenti (10) raggiunto per questa conversazione',
  chatProtocol: 'ChatProtocol',
  showMore: 'Mostra di più',
  showLess: 'Mostra meno',
  uploadTooltip: 'Carica file',
  uploadFilesTooltip: 'Carica file',
  pdfDownloadTooltip: 'Scarica la conversazione',
  feedbackDescription: 'Feedback',
  feedbackSubtitle: {
    description:
      'Qui può inviarci suggerimenti, proposte e richieste di carattere generale',
    note: 'La preghiamo di notare che non possiamo rispondere',
    hint:
      'Tutte le altre preoccupazioni che riguardano specificamente la sua locazione o la ricerca di un appartamento possono esserci descritte nella chat.'
  },
  feedbackPlaceholder: 'Inserisca qui il suo messaggio...',
  feedbackInfoPlaceholder: 'Sentiti libero di aggiungere dettagli specifici qui...',
  sendFeedback: 'Invia',
  giveFeedback: 'Feedback',
  feedbackSubmittedSuccessfully: 'Il suo feedback è stato inviato con successo',
  character_limit: 'Caratteri',
  page: 'p.',
  factually_incorrect: 'Non corretto dal punto di vista fattuale',
  not_following_instructions: 'Non ha seguito completamente le istruzioni',
  info_not_in_document: 'Informazione non trovata nel documento',
  inappropriate_or_offensive: 'Inappropriato o offensivo',
  irrelevant: 'Non Pertinente',
  not_fitting_topic: "Non adatto all'argomento",
  confusing_information: 'Informazioni confuse',
  ignored_important_parts_of_document:
    'Parti importanti del documento ignorate',
  interpreted_document_wrong: 'Interpretazione errata del documento',
  answer_to_generic: 'Risposta generica',
  sources_incorrect: 'Fonti non affidabili o citazioni errate',
  why_not_helpful: 'Perché non è stato utile?',
  thank_you_feedback: 'Grazie per il tuo feedback!',
  provide_feedback: 'Fornisci feedback a questa risposta',
  not_helpful: 'Non utile',
  helpful: 'Utile',
  regenerate_message: 'Rigenera',
  copy_message: 'Copia',
  copied_message: 'Copiato!',
  copy_table_csv: 'Copia tabella',
  download_table_csv: 'Scarica CSV',
  expand_table: 'Apri tabella',
  print: 'Stampa',
  original_answer: 'Risposta originale',
  regenerated_answer: 'Risposta rigenerata',
  thinking_message: 'Sto pensando...',
  file_path: 'Percorso file: ',
  new_messages: 'Nuovi messaggi',
  previous_message: 'Messaggio precedente',
  next_message: 'Messaggio successivo',
  clear_input: 'Cancella input',
  open_feedback: 'Apri feedback',
  file_upload: 'Caricamento file',
  expand_quickreplies_aria: 'Mostra più pulsanti',
  button_tooltip_switch_locale_german: 'Cambia lingua in tedesco',
  button_tooltip_switch_locale_french: 'Cambia lingua in francese',
  button_tooltip_switch_locale_dutch: 'Cambia lingua in olandese',
  button_tooltip_switch_locale_turkish: 'Cambia lingua in turco',
  button_tooltip_switch_locale_russian: 'Cambia lingua in russo',
  button_tooltip_switch_locale_swedish: 'Cambia lingua in svedese',
  button_tooltip_switch_locale_ukranian: 'Cambia lingua in ucraino',
  button_tooltip_switch_locale_spanish: 'Cambia lingua in spagnolo',
  button_tooltip_switch_locale_polish: 'Cambia lingua in polacco',
  button_tooltip_switch_locale_arabic: 'Cambia lingua in arabo',
  button_tooltip_switch_locale_italian: 'Cambia lingua in italiano',
  button_tooltip_switch_locale_english: 'Cambia lingua in inglese',
  message_from_you: 'Tu dici',
  message_from_bot: 'Il bot dice',
  message_from_operator: 'L\'agente dice',
  new_message_from_bot: 'Il bot dice',
  empty_message_received: 'Messaggio vuoto ricevuto',
  open_quick_actions: 'Apri azioni rapide',
  quick_actions: 'Azioni rapide',
  quick_actions_search_hint: '...o continua a digitare per suggerimenti',
  quick_actions_no_results: 'Nessun risultato trovato'
}
